<template>
  <div class="footer">
    <!--footer-->
    <div class="page-width">
      <div class="clear">
        <div class="footer_left">
          <ul>
            <!-- <li>{{ $t('info')}}</li> -->
            <!-- <router-link to="/contact-us">{{ $t('contact') }}</router-link> -->
            <li @click="$router.push({path:'/about-us'})">{{ $t('aboutUs')}}</li>
            <li @click="$router.push({path:'/privacy'})">{{ $t('privacyTitle')}}</li>
            <li @click="$router.push({path:'/terms-of-service'})">{{ $t('terms')}}</li>
            <li @click="$router.push({path:'/contact-us'})">{{ $t('contact')}}</li>
          </ul>
        </div>
      </div>
    </div>
    <!--end footer-->

    <div class="page-width">
      <img class="Pay" src="../assets/img/payment.png" alt="">
    </div>
  </div>
</template>

<script>           
import { Config } from '../../config/default';
import { mapState } from 'vuex'
export default {
  name: "munFooter",
  data() {
    return{
      companyFB: Config.COMPANY_FB,
      companyIG: Config.COMPANY_IG,
    }
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn
  })
}
</script>

<style scoped lang="less">
@import "../assets/css/footer.less";
</style>



// WEBPACK FOOTER //
// src/components/munFooter.vue